import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Target } from "lucide-react";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const API = process.env.REACT_APP_BACKEND_URL;

export default function MisyonPage() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/api/about`).then((r) => setAbout(r.data)).catch(() => {});
  }, []);

  if (!about) return null;

  return (
    <div className="min-h-screen bg-white" data-testid="misyon-page">
      <Navbar />
      {/* Hero */}
      <div className="pt-20 bg-gradient-to-b from-[#0C0C0C] to-[#1a1a2e] text-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="overline justify-start mb-5 text-white/60">Hakkımızda</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter" style={{ fontFamily: "Outfit" }}>
            <span className="text-[#FF5A00]">{about.mission_title}</span>
          </motion.h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20">
        <div className={`grid ${about.mission_image ? "lg:grid-cols-2" : ""} gap-16 items-center`}>
          {about.mission_image && (
            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="rounded-3xl overflow-hidden shadow-xl">
              <img src={about.mission_image} alt="Misyon" className="w-full h-[400px] lg:h-[500px] object-cover" loading="lazy" />
            </motion.div>
          )}
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <div className="w-16 h-16 rounded-2xl bg-[#FFF0E6] flex items-center justify-center mb-6">
              <Target size={28} className="text-[#FF5A00]" />
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tighter text-[#0C0C0C] mb-8" style={{ fontFamily: "Outfit" }}>
              {about.mission_title}
            </h2>
            <div className="text-gray-600 leading-relaxed text-lg whitespace-pre-line">{about.mission_text}</div>
          </motion.div>
        </div>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
